import React, { useMemo } from 'react';
import cn from 'clsx';

import { useAemContent } from '../../shared/hooks/hooks';

import { getBusinessHours } from '../../shared/utils/time/time';

import {
  AEM_CONTENT_IDS,
  AEM_CONTENT_PAGE_IDS
} from '../../shared/constants/cms';

import styles from './cec-hours.scss';

function CECHours() {
  const { aemTooltipsContent } = useAemContent(AEM_CONTENT_PAGE_IDS.global);

  const cecMfHours = aemTooltipsContent?.[AEM_CONTENT_IDS.cecMfHours];
  const cecSatHours = aemTooltipsContent?.[AEM_CONTENT_IDS.cecSatHours];

  const formatCecHours = (startDate: Date, endDate: Date) =>
    `${startDate
      .toLocaleTimeString([], {
        hour: 'numeric',
        hour12: true
      })
      .replace(' ', '')} - ${endDate
      .toLocaleTimeString([], {
        hour: 'numeric',
        hour12: true,
        timeZoneName: 'shortGeneric'
      })
      .replace(' ', '')}`;

  const businessHours = useMemo(() => {
    const { mondayFridayClose, mondayFridayOpen, saturdayClose, saturdayOpen } =
      getBusinessHours();

    return {
      mondayFriday: formatCecHours(mondayFridayOpen, mondayFridayClose),
      saturday: formatCecHours(saturdayOpen, saturdayClose)
    };
  }, []);

  return (
    <div className={cn(styles['container'], 'cec-hours')}>
      <div>
        <span className={styles['title']}>{cecMfHours?.title}</span>
        <span className={styles['hours']}>{businessHours.mondayFriday}</span>
      </div>
      <div>
        <span className={cn(styles['divider'], 'cec-hours__divider')}>|</span>

        <span className={styles['title']}>{cecSatHours?.title}</span>
        <span>{businessHours.saturday}</span>
      </div>
    </div>
  );
}

export default CECHours;
